import { render, staticRenderFns } from "./EditMilestones.vue?vue&type=template&id=30adbd3a&"
import script from "./EditMilestones.vue?vue&type=script&lang=js&"
export * from "./EditMilestones.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\KoushalManna\\Projects\\NPCC\\NPCC_UI\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('30adbd3a')) {
      api.createRecord('30adbd3a', component.options)
    } else {
      api.reload('30adbd3a', component.options)
    }
    module.hot.accept("./EditMilestones.vue?vue&type=template&id=30adbd3a&", function () {
      api.rerender('30adbd3a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/projectmanagement/EditMilestones.vue"
export default component.exports